import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px 0'
  },
  buttonGroup: {
    backgroundColor: theme.palette.grey[400], // Light gray background for the button group
    borderRadius: '8px',
    gap: 5, // Rounded corners for the whole button group
    padding: '6px 6px' // Slight padding around buttons for consistent look
  },
  button: {
    border: 'none',
    fontSize: '0.875rem', // Slightly smaller text
    padding: '6px 16px', // Padding inside buttons
    borderRadius: '8px !important', // Match the rounded style from the screenshot
    backgroundColor: theme.palette.grey[400], // Light background for inactive buttons
    textTransform: 'none', // Keep text capitalization as provided in labels
    '&:hover': {
      backgroundColor: '#d1d5da' // Hover effect for buttons
    },
    '&.selected': {
      backgroundColor: theme.palette.grey[100]
    }
  }
}))
